import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import FacebookIcon from '@material-ui/icons/Facebook';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { useResultShareBlockStyles } from './ResultShareBlock.styles';

type ResultShareBlockProps = {
  testUrl: string;
  shareTitle?: string;
  onHelpClick: () => void;
};

const ResultShareBlock = ({ testUrl, shareTitle, onHelpClick }: ResultShareBlockProps) => {
  const classes = useResultShareBlockStyles();

  return (
    <div className={classes.shareBlock}>
      <div className={classes.shareRow}>
        <span className={classes.shareTitle}>Partager ce test</span>
        <div className={classes.shareIcons}>
          <TwitterShareButton url={testUrl} title={shareTitle}>
            <span className={classes.shareIconButton} aria-label="Partager sur Twitter">
              <TwitterIcon style={{ fontSize: 16 }} />
            </span>
          </TwitterShareButton>
          <FacebookShareButton url={testUrl} title={shareTitle}>
            <span className={classes.shareIconButton} aria-label="Partager sur Facebook">
              <FacebookIcon style={{ fontSize: 16 }} />
            </span>
          </FacebookShareButton>
          <LinkedinShareButton url={testUrl} title={shareTitle}>
            <span className={classes.shareIconButton} aria-label="Partager sur LinkedIn">
              <LinkedInIcon style={{ fontSize: 16 }} />
            </span>
          </LinkedinShareButton>
        </div>
        <button
          type="button"
          className={classes.copyLinkButton}
          onClick={() => navigator.clipboard.writeText(testUrl)}>
          <FileCopyOutlinedIcon style={{ fontSize: 16 }} />
          Copier le lien
        </button>
      </div>
      <div
        className={classes.helpRow}
        onClick={onHelpClick}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onHelpClick();
          }
        }}
        role="button"
        tabIndex={0}>
        <div className={classes.helpLabels}>
          <span className={classes.helpTitle}>Besoin d&apos;aide ?</span>
          <span className={classes.helpContact}>Contactez-nous</span>
        </div>
        <span className={classes.helpIconWrap}>
          <ArrowForwardIcon className={classes.helpIcon} />
        </span>
      </div>
    </div>
  );
};

export default ResultShareBlock;
